module.exports = __webpack_public_path__ + "static/media/font-logo-stg.14f31879.svg";